module.exports = __webpack_public_path__ + "img/nobleriding_main_03.96423e5c.jpg";